import { CandidateProfileFormData } from 'features/profile/types';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { ConnectedLocationAutocomplete } from 'shared/components';

import LargerInputContainer from './LargerInputContainer';

export default function FieldLocation() {
    const { control } = useFormContext<CandidateProfileFormData>();
    const { t } = useTranslation('profile');

    return (
        <LargerInputContainer>
            <ConnectedLocationAutocomplete control={ control }
                name="location"
                label={ t('fields.location') }
            />
        </LargerInputContainer>
    );
}
